export default function PHP_serialize() {
  return (
    <div>
      <h1>PHP_serialize</h1>
    </div>
  );
}
